import type { ActionType, IState } from './types';

export const initialState: IState = {
  templateName: '',
  templateIcon: 'barColored',
  template: null,
  isActive: true,
  errors: {
    syntaxError: null,
    chartError: null,
  },
};

export function reducer(state: IState, action: ActionType): IState {
  switch (action.type) {
    case 'SET_TEMPLATE_NAME':
      return { ...state, templateName: action.payload };
    case 'SET_TEMPLATE':
      return {
        ...action.payload,
        errors: { chartError: null, syntaxError: null },
      };
    case 'SET_IS_ACTIVE':
      return { ...state, isActive: action.payload };
    case 'SET_ICON':
      return { ...state, templateIcon: action.payload };
    case 'SET_ERROR':
      return {
        ...state,
        errors: { ...state.errors, ...action.payload },
      };
    default:
      return state;
  }
}
